import { render, staticRenderFns } from "./ListVouchers.vue?vue&type=template&id=20a61c0a&scoped=true"
import script from "./ListVouchers.vue?vue&type=script&lang=js"
export * from "./ListVouchers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a61c0a",
  null
  
)

export default component.exports